import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { TokenInterceptor } from './core/interceptors/token-interceptor/token.interceptor';
import { httpLoadingInterceptor } from './core/interceptors/http-loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-right',
      progressBar: true,
      timeOut: 3000,
      easing: 'ease-in',
      easeTime: 300,
      preventDuplicates: true,
    }),

    provideHttpClient(
      withFetch(),
      withInterceptors([
        TokenInterceptor,
        httpLoadingInterceptor
      ])
    )
  ]
};
